import { formatOffsetDatesInText } from '@app/core/utils/format-offset-dates-in-text';

export function flattenErrors(errorResponse: unknown, locale: string): string[] {
  if (!isValidationErrorResponse(errorResponse)) return [];

  const errs = errorResponse?.errors;

  return Object.entries(errs).flatMap(([key, messages]) =>
    messages.map(message => `${key} - ${formatOffsetDatesInText(message, locale)}`)
  );
}

function isValidationErrorResponse(value: unknown): value is { errors: Record<string, string[]> } {
  if (!value || typeof value !== 'object' || !('errors' in value)) {
    return false;
  }

  const errors = value.errors;
  return !!errors &&
    typeof errors === 'object' &&
    Object.values(errors).every(messages => Array.isArray(messages) && messages.every(message => typeof message === 'string'));
}
